import React from "react";
import { Row } from "./Row/Row";
import { ResultsInIndex } from "./ResultsInIndex/ResultsInIndex";
import { Highlight } from "./Highlight/Highlight";
import { useNormalisedHits } from "@/features/search/components/Results/hooks/useNormalisedHits";
import { PickemImage } from "@/features/pickems/components/PickemImage";
import { getLogos } from "@/features/pickems/util/helpers";
import { useTitles } from "@/hooks/graphql/useTitles";
import { PickIcon } from "@picklebet/ui";
import type { PickemsHit } from "@/features/search/components/Results/models/pickemsHit";

export const PickemsResults = () => {
  const { items, results } = useNormalisedHits<PickemsHit>();
  const allTitles = useTitles();

  return (
    <ResultsInIndex
      indexName={`Pickems`}
      total={results?.nbHits || 0}
      pages={results?.nbPages || 0}
      perPage={results?.hitsPerPage || 0}
    >
      {(items || []).map((item) => {
        const categoryHighlight = item.normalisedHighlights?.category?.[0];
        const titleHighlight = item.normalisedHighlights?.title?.[0];
        return (
          <Row
            key={item.objectID}
            eventId={item.objectID}
            icon={
              item.cardImageUri || item.sports.length > 0 ? (
                <PickemImage
                  image={
                    item.cardImageUri
                      ? item.cardImageUri
                      : getLogos(item.sports.slice(0, 1), allTitles)
                  }
                  altText={item.title}
                />
              ) : (
                <PickIcon />
              )
            }
            title={
              <Highlight
                text={item.category}
                matchedWords={categoryHighlight?.matchedWords || []}
                html={categoryHighlight?.value || ""}
              />
            }
            subTitle={
              <Highlight
                text={item.title}
                matchedWords={titleHighlight?.matchedWords || []}
                html={titleHighlight?.value || ""}
              />
            }
            to={`/pickems/contest/${item.objectID}/pick/`}
          />
        );
      })}
    </ResultsInIndex>
  );
};
